//START GENAI@GHCOPILOT
import { error } from 'common/errors';
import { getState } from 'orch-communicator/store';

export const waitForSDKs = async (timeout = 50000, interval = 100) => {
  const startTime = Date.now();
  //eslint-disable-next-line
  while (true) {
    if (getState().sdksReady) {
      return true;
    }

    if (Date.now() - startTime >= timeout) {
      throw error(`Failed to load INO SRC SDKs.`);
    }

    await new Promise(resolve => setTimeout(resolve, interval));
  }
};
//END GENAI@GHCOPILOT
